import { useEffect, useState } from "react";
import { ENTITY_POLL_MS } from "../constants/polling";

// The entity-list revalidate beat (#692 — 5s, same cadence as the status poll).
// `online` is frozen true (#912), so this always ticks now; it still pauses
// while the tab is hidden — an announcer who has switched away is not reading
// the screen. Downstream fetches are caught/cached, so a real offline stretch
// degrades gracefully rather than needing this tick paused.
export function useEntityTick(online) {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!online) return undefined;
    const id = setInterval(() => {
      if (document.visibilityState === "hidden") return;
      setTick((n) => n + 1);
    }, ENTITY_POLL_MS);
    return () => clearInterval(id);
  }, [online]);
  return tick;
}
